import { inject, Injectable } from '@angular/core';
import { IonicSafeString, ToastController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private isFired: boolean = false;

  private readonly toastController = inject(ToastController);

  async showToast(
    header: string,
    message: string | IonicSafeString,
    position: 'top' | 'bottom' | 'middle',
    color: string,
    duration: number = 2000,
    cssClass: string = 'ion-text-center',
  ): Promise<void> {
    if (!this.isFired) {
      this.isFired = true;
      const toast: HTMLIonToastElement = await this.toastController.create({
        header,
        message,
        duration,
        position,
        color,
        cssClass,
      });

      await toast.present();
      void toast.onDidDismiss().then(() => (this.isFired = false));
    }
  }

  async showDismissableToast(
    message: string | IonicSafeString,
    position: 'top' | 'bottom' | 'middle' = 'top',
    color: string = 'white',
  ): Promise<void> {
    if (!this.isFired) {
      this.isFired = true;
      const toast: HTMLIonToastElement = await this.toastController.create({
        message,
        position,
        color,
        animated: true,
        buttons: [{ icon: 'close-outline', role: 'cancel', handler: () => {} }],
      });

      await toast.present();
      void toast.onDidDismiss().then(() => (this.isFired = false));
    }
  }
}
